/* unplugin-vue-components disabled */import { render } from "./invited_ewm.vue?vue&type=template&id=5fa8132c&scoped=true"
import script from "./invited_ewm.vue?vue&type=script&lang=js"
export * from "./invited_ewm.vue?vue&type=script&lang=js"

import "./invited_ewm.vue?vue&type=style&index=0&id=5fa8132c&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa8132c"]])

export default __exports__